export default __webpack_public_path__ + "img/Cinnamomum_kanehirae.901c29ac.jpg";